import type { CSSProperties } from "react";

/**
 * Animated grid background for the Login page.
 *
 * - Renders a fine grid via CSS gradients
 * - Eight light streaks (4 horizontal + 4 vertical) flow along the grid lines
 * - Pure CSS / GPU-accelerated transforms; no JS animation loop
 * - Color palette switches with `.dark` selector via CSS variables
 * - Respects `prefers-reduced-motion` (handled in theme.css)
 */
export function LoginBackground() {
  const horizontalFlows: CSSProperties[] = [
    { top: "calc(var(--login-grid-size) * 1 - 1px)", animationDelay: "-1.6s", animationDuration: "6.8s" },
    { top: "calc(var(--login-grid-size) * 4 - 1px)", animationDelay: "-5.2s", animationDuration: "8.2s" },
    { top: "calc(var(--login-grid-size) * 7 - 1px)", animationDelay: "-3.7s", animationDuration: "7.4s" },
    { top: "calc(var(--login-grid-size) * 10 - 1px)", animationDelay: "-6.9s", animationDuration: "8.8s" },
  ];

  const verticalFlows: CSSProperties[] = [
    { left: "calc(var(--login-grid-size) * 2 - 1px)", animationDelay: "-2.2s", animationDuration: "7.1s" },
    { left: "calc(var(--login-grid-size) * 6 - 1px)", animationDelay: "-6.4s", animationDuration: "8.6s" },
    { left: "calc(var(--login-grid-size) * 10 - 1px)", animationDelay: "-4.8s", animationDuration: "7.8s" },
    { left: "calc(var(--login-grid-size) * 14 - 1px)", animationDelay: "-7.5s", animationDuration: "8.4s" },
  ];

  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-hidden z-0"
    >
      <div className="absolute inset-0 login-bg-grid" />
      <div className="absolute inset-0 login-bg-mask" />
      <div className="absolute inset-0 login-bg-glow" />

      {horizontalFlows.map((style, i) => (
        <span
          key={`h-${i}`}
          className="login-bg-flow login-bg-flow-h"
          style={style}
        />
      ))}

      {verticalFlows.map((style, i) => (
        <span
          key={`v-${i}`}
          className="login-bg-flow login-bg-flow-v"
          style={style}
        />
      ))}
    </div>
  );
}
